import { EuiCheckbox } from "@inscopix/ideas-eui";
import { Dispatch, SetStateAction } from "react";

interface CellEditorFileFooterProps {
  setSelectedTableId: Dispatch<SetStateAction<string | undefined>>;
  setSelectedRowId: Dispatch<SetStateAction<string | undefined>>;
  setSelectedColumnId: Dispatch<SetStateAction<string | undefined>>;
  hideInvalidFiles: boolean;
  setHideInvalidFiles: Dispatch<SetStateAction<boolean>>;
}

export const CellEditorFileFooter = ({
  setSelectedTableId,
  setSelectedRowId,
  setSelectedColumnId,
  hideInvalidFiles,
  setHideInvalidFiles,
}: CellEditorFileFooterProps) => {
  return (
    <EuiCheckbox
      id="hide_invalid_files"
      label="Hide options that do not contain a matching file"
      checked={hideInvalidFiles}
      onChange={(e) => {
        setHideInvalidFiles(e.target.checked);
        setSelectedTableId(undefined);
        setSelectedRowId(undefined);
        setSelectedColumnId(undefined);
      }}
    />
  );
};
